export default "__VITE_ASSET__CsCtOs8i__"